/* global axios */
import ApiClient from './ApiClient';

class OrganizationAPI extends ApiClient {
  constructor() {
    super('organization', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  saveSettings(data) {
    return axios.patch(this.url, data);
  }

  addMember(data) {
    return axios.post(`${this.url}/provision`, data);
  }

  inviteMember(data) {
    return axios.post(`${this.url}/provision`, data);
  }

  getWhatsappQr(userId = null) {
    const params = userId ? `user_id=${userId}` : '';
    return axios.get(`${this.url}/whatsapp_qr?${params}`);
  }

  whatsappConnect({ reset = false } = {}) {
    return axios.post(`${this.url}/whatsapp_connect`, { reset });
  }

  removeMember(memberId) {
    return axios.delete(`${this.url}/agents/${memberId}`);
  }

  moveConsultant(userId, teamId) {
    return axios.patch(`${this.url}/agents/${userId}/move_team`, { team_id: teamId });
  }
}

export default new OrganizationAPI();
